module.exports = __webpack_public_path__ + "img/hotel-low-priority.130c392e.svg";